import { CognitoAdapterBase } from "../../../services/auth/cognito-adapter-base";
import type { ServiceKey } from "../../../services/auth/types";

/**
 * LogoCloud authenticates against Cognito (pool in us-east-1, encoded in
 * cfg.hostedUiDomain) and emits a single header on every API call:
 *
 *   Authorization: Bearer <id token>
 *
 * Unlike MyQueue/Deckorate, the LogoCloud API does not require poolid/region
 * headers — the JWT alone is sufficient. cfg.poolId/region are still used by
 * the OAuth flow (token endpoint, refresh) via CognitoAdapterBase.
 */
export class LogoCloudAuthAdapter extends CognitoAdapterBase {
  readonly key: ServiceKey = "logocloud";
  readonly category = "branding";

  getAuthHeaders(): Record<string, string> {
    if (!this.tokens) return {};
    return {
      authorization: `Bearer ${this.tokens.idToken}`,
    };
  }
}
